import { FC } from 'react';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { ModalBodyContentProps } from '@/types';
import { ModalSlicePartnerListPrimary } from '../../../../../prismicio-types';

const subtitleComponents = (className: string): JSXMapSerializer => ({
  paragraph: ({ children }) => <p className={className}>{children}</p>,
});

export const PartnerList: FC<
  ModalBodyContentProps<ModalSlicePartnerListPrimary>
> = ({ data, styles, components }) => {
  return (
    <>
      <PrismicRichText field={data.title} components={components} />
      <PrismicRichText
        field={data.subtitle}
        components={subtitleComponents(styles.subtitle)}
      />

      <div className={styles.listWrapper}>
        <PrismicRichText field={data.list_1} />
        <PrismicRichText field={data.list_2} />
      </div>
    </>
  );
};
